<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title>ACTIVIT&Eacute;</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div class="btn">
      <button
        mat-raised-button
        class="colorGreen button-row"
        (click)="afficher()"
      >
        <mat-icon>search</mat-icon>Afficher
      </button>
    </div>
    <div class="displayFlex2">
      <mat-card>
        <h5>Période</h5>
        <mat-form-field appearance="outline" style="width: 105px">
          <mat-label>Année</mat-label>
          <mat-select
            placeholder="Année"
            [(ngModel)]="annee"
            (selectionChange)="setListeAction()"
          >
            <mat-option *ngFor="let annee of anneeTab" [value]="annee">
              {{ annee }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
        <mat-form-field
          appearance="outline"
          style="width: 105px"
          *ngIf="showMonth"
        >
          <mat-label>Mois</mat-label>
          <!-- (selectionChange)="onDateChange($event.value)" -->
          <mat-select
            placeholder="Mois"
            [(ngModel)]="mois"
            (selectionChange)="setListeAction()"
          >
            <mat-option *ngFor="let mois of moisTab; let i = index" [value]="i">
              {{ mois }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card>
      <mat-card>
        <h5>Liste Collaborateurs</h5>
        <button (click)="selectAllCollaborateurs()" mat-button>
          <mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner
        </button>
        <button (click)="deSelectAllCollaborateurs()" mat-button>
          <mat-icon>close</mat-icon>&nbsp;Annuler
        </button>
        <div style="border: 1px solid rgb(226, 224, 230) !important">
          <mat-selection-list
            name="Perso_Matricule"
            #liste_Coll
            (selectionChange)="
              onSelectionColl(liste_Coll.selectedOptions.selected)
            "
            style="height: 100px; overflow-y: scroll"
          >
            <mat-list-option
              [ngStyle]="{ height: '35px' }"
              [(ngModel)]="collaborateur.Perso_Matricule"
              *ngFor="let collaborateur of listeCollaborateur"
            >
              {{ collaborateur.Perso_Nom + " " + collaborateur.Perso_Prenom }}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>

      <mat-card>
        <h5>Liste Clients</h5>
        <button (click)="selectAllClients()" mat-button>
          <mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner
        </button>
        <button (click)="deSelectAllClients()" mat-button>
          <mat-icon>close</mat-icon>&nbsp;Annuler
        </button>
        <div style="border: 1px solid rgb(226, 224, 230) !important">
          <mat-selection-list
            name="myclient"
            #liste_Client
            (selectionChange)="
              onSelectionClient(liste_Client.selectedOptions.selected)
            "
            style="height: 100px; overflow-y: scroll"
          >
            <mat-list-option
              [ngStyle]="{ height: '35px' }"
              [(ngModel)]="client.Tiers_Code"
              *ngFor="let client of listeClient"
            >
              {{ client.Tiers_NomPublic }}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>
      <mat-card>
        <h5>Liste Actions</h5>
        <button (click)="selectAllActions()" mat-button>
          <mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner
        </button>
        <button (click)="deSelectAllActions()" mat-button>
          <mat-icon>close</mat-icon>&nbsp;Annuler
        </button>
        <div style="border: 1px solid rgb(226, 224, 230) !important">
          <mat-selection-list
            name="myaction"
            #liste_Action
            (selectionChange)="
              onSelectionAction(liste_Action.selectedOptions.selected)
            "
            style="height: 100px; overflow-y: scroll"
          >
            <mat-list-option
              [ngStyle]="{ height: '35px' }"
              [(ngModel)]="action.avtAction_Code"
              *ngFor="let action of listeAction"
            >
              {{ action.avtAction_Intitule }}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>
    </div>
    <mat-card style="margin-top: 10px">
      <table *ngIf="showTable" mat-table [dataSource]="dataSource">
        <ng-container
          *ngFor="let column of tbrecherche; let i = index"
          matColumnDef="{{ column.TableRD_Champs }}"
        >
          <th
            style="
              background-color: rgb(171 196 247);
              padding: 0 1px 0 1px;
              color: white;
            "
            [ngStyle]="{ width: column.TableRD_Largeur }"
            mat-header-cell
            *matHeaderCellDef
          >
            <div style="text-align: center; width: 100%">
              {{ column.TableRD_Des }}
            </div>
          </th>
          <td mat-cell *matCellDef="let row">
            <div
              style="display: flex"
              [ngStyle]="row[column.TableRD_Champs].style"
            >
              <div style="height: 100%">
                <button
                  *ngIf="row[column.TableRD_Champs].show"
                  mat-icon-button
                  color="primary"
                >
                  <mat-icon (click)="toggleRow(row)">{{
                    row[column.TableRD_Champs].icon
                  }}</mat-icon>
                </button>
              </div>
              <div style="height: 100%; width: 100%; margin-top: 10px">
                <div *ngIf="row[column.TableRD_Champs].RS != 0">
                  {{ row[column.TableRD_Champs].RS }}
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card>
  </mat-card-content>
</mat-card>
